import { render, staticRenderFns } from "./RecordingBucketBrowser.vue?vue&type=template&id=58f9795d&"
import script from "./RecordingBucketBrowser.vue?vue&type=script&lang=js&"
export * from "./RecordingBucketBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports